import {Card} from "antd";
import PatientGrid from "./PatientGrid";
import PatientFilter from "./PatientFilter";
import {DataGridProvider} from "../../../core/components/data-grid/DataGridContext";
import SimpleLayout from "../../../core/components/layout/SimpleLayout";
import {t} from "i18next";
import {useEffect} from "react";
import AppConfig from "../../../core/service/AppConfig";

export default function PatientGridApp()
{
    useEffect(() => {
        document.title = `${t('Patients')} - ${AppConfig.getHisTitle()}`
    }, []);

    return (
        <SimpleLayout fullWidth={true}>
            <Card title={t('Patients')}>
                <DataGridProvider
                    defaultFilter={{Validate: true}}
                >
                    <PatientGrid />
                </DataGridProvider>
            </Card>
        </SimpleLayout>
    )
}